<template>
  <div class="forum-detail component-container">
    <div class="container-head contain-btn-title">
      <div class="container-head-title">
        <common-button
          size="default"
          type="cancel"
          style="float: right"
          image
          @click="goBack()"
          >返回</common-button
        >
      </div>
    </div>
    <div class="container-body">
      <div class="forum-panel">
        <div class="detail-title">
          <div class="detail-title-text">{{ caseDiscuss.postTitle }}</div>
          <div class="other-info">
            <span class="detail-author">{{ caseDiscuss.userName }}</span>
            <span class="detail-time">{{
              caseDiscuss.createTm | datetimeFormat
            }}</span>
          </div>
        </div>
        <div class="detail-body">
          <p
            class="detail-content"
            v-if="caseDiscuss.postContent"
            v-html="caseDiscuss.postContent"
          ></p>
          <span
            class="default-content iconfont"
            title="点击加入讨论"
            @click="applyHandler"
            v-else
            >{{ defaultContent }}</span
          >
          <div
            class="detail-attachment-panel"
            v-if="caseDiscuss.attachments && caseDiscuss.attachments.length"
          >
            <p class="tag">附件栏</p>
            <div class="detail-attachment-items">
              <div v-for="item of caseDiscuss.attachments" :key="item.id">
                <span
                  class="detail-attachment-item"
                  @click="handleViewOrDownLoadAttachment(item)"
                >
                  <div class="attachment-item-up">
                    <span class="up-left">
                      <span class="attachment-name">
                        {{ item.attachmentName || item.attachmentOriginalName }}
                      </span>
                      <span class="attachment-size">{{
                        item.attachmentSize | fileSizeUnit
                      }}</span>
                    </span>
                    <span
                      class="up-right iconfont"
                      :class="item | fileIcon(that)"
                      :style="item | fileColor(that)"
                    ></span>
                  </div>
                  <div class="attachment-item-down">
                    红砖智库系统
                  </div>
                </span>
              </div>

              <!--占位-->
              <div
                v-for="i of 20"
                :key="i"
                style="width: 220px;height: 0;margin-top: 0;margin-bottom: 0"
              ></div>
            </div>
          </div>
        </div>

        <div class="detail-footer-panel" v-if="showParticipant">
          <p class="tag">参与人</p>
          <div class="member-item-wrapper">
            <div
              v-for="item of caseDiscuss.users"
              :key="item.userId"
              @click="handleShowUserInfo(item)"
            >
              <span class="member-item">
                <div
                  class="member-item-up"
                  :style="`background-image: url(${avatarPre}/${item.avatar})`"
                ></div>
                <div class="member-item-down">
                  <div class="user-name" :title="item.name">
                    {{ item.name }}
                  </div>
                </div>
              </span>
            </div>
            <span
              class="member-item member-item-add"
              v-if="caseDiscuss.postContent && !$route.query.tmp"
            >
              <div
                class="member-item-up icon-tianjia iconfont"
                style="cursor: pointer"
                @click="handleInviteMember()"
              ></div>
              <div class="member-item-down">
                <div class="user-name" style="color: transparent;">(添加)</div>
              </div>
            </span>
            <span
              v-if="
                currUserId === caseDiscuss.createUserId && !$route.query.tmp
              "
              class="member-item member-item-reduce"
            >
              <div
                class="member-item-up icon-jianshao iconfont"
                style="cursor: pointer"
                @click="handleRemoveMember()"
              ></div>
              <div class="member-item-down">
                <div class="user-name" style="color: transparent">(剔除)</div>
              </div>
            </span>

            <!--占位-->
            <div
              v-for="i of 60"
              :key="i"
              style="width: 50px;height: 0;margin-top: 0;margin-bottom: 0;padding: 0"
            ></div>
          </div>
          <div>
            <p class="tag" v-if="caseDiscuss.rejectReason">
              审核人：{{ caseDiscuss.approveUserName }}
            </p>
          </div>
          <div>
            <p class="tag" v-if="caseDiscuss.rejectReason">
              拒绝原因：{{ caseDiscuss.rejectReason }}
            </p>
          </div>
        </div>
        <el-dialog
          class="view-dialog"
          :visible.sync="view.viewDialogFlag"
          @close="view.viewDialogFlag = false"
        >
          <div style="height: 600px;overflow-y: auto">
            <userInfo
              v-if="view.viewDialogFlag"
              :userId="view.userId"
            ></userInfo>
          </div>
        </el-dialog>
      </div>
    </div>

    <el-dialog
      title="申请提示"
      :visible.sync="applyDialogVisible"
      center
      width="30%"
    >
      <span>是否向发布者申请加入？</span>
      <span slot="footer" class="dialog-footer">
        <common-button
          @click="applyDialogVisible = false"
          type="cancel"
          image
          size="default"
          >取 消</common-button
        >
        <common-button
          @click="sureApplyHandler"
          type="primary"
          image
          size="default"
          >确 定</common-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="附件预览提示"
      :visible.sync="attachmentPreviewVisible"
      center
      width="30%"
    >
      <span>本附件支持在线预览，是否跳转预览？</span>
      <span slot="footer" class="dialog-footer">
        <common-button
          @click="downloadAttachment(currentAttachment)"
          type="primary"
          image
          size="small"
          >下 载</common-button
        >
        <common-button
          @click="previewAttachment(currentAttachment)"
          type="primary"
          image
          size="small"
          >预 览</common-button
        >
        <common-button
          @click="attachmentPreviewVisible = false"
          type="cancel"
          image
          size="small"
          >取 消</common-button
        >
      </span>
    </el-dialog>

    <animation
      :loadingDataVisible="caseDiscuss.isLoading"
      :loadingText="'加载中'"
    />

    <participant-dialog
      :callback="handleCallback"
      :discuss="caseDiscuss"
      :type="type"
      :visible.sync="participantDialogVisible"
      :title="title"
    ></participant-dialog>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import animation from "@/components/loading/animation";
import { Message } from "element-ui";
import { mapState } from "vuex";
import { ATTA_FILE_SHOW_TYPE } from "@/constants/constants";
import { generateStandardSpan } from "@/utils/acquireStandardSpan";
import ParticipantDialog from "@/components/detail/ParticipantDialog";
import ForumInvite from "@/components/detail/ForumInvite";
import userInfo from "@/pages/user/userInfo";

export default {
  name: "ForumDetail",
  data() {
    return {
      participantDialogVisible: false,
      attachmentPreviewVisible: false,
      applyDialogVisible: false,
      showPreview: false,
      spanTimeout: null,
      that: this,
      avatarPre: window.config.avatar.baseUrl,
      defaultContent: "由于您没有被邀请到此讨论中，部分内容被折叠，点击加入",
      caseDiscuss: {
        isLoading: false,
        attachments: [],
        users: []
      },
      view: {
        userId: "",
        viewDialogFlag: false
      },
      //当前用户的id
      currUserId: "",
      //灵敏度
      attachmentSensitive: 250,
      //默认span
      attachmentSpan: 6,
      memberSpan: 3,
      memberSensitive: 60,
      //准备的颜色的数组
      attachmentColors: {
        ppt: "#fd585e",
        doc: "#2a83eb",
        docx: "#2a83eb",
        xls: "#16b881",
        xlsx: "#16b881",
        pdf: "#a29bfe",
        jpg: "#a29bfe",
        png: "#a29bfe",
        gif: "#a29bfe",
        jpeg: "#a29bfe",
        txt: "#ff734c",
        unKnown: "#5c5b5b"
      },
      fileIconType: {
        ppt: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        doc: "icon-file-word-fill",
        docx: "icon-file-word-fill",
        pdf: "icon-file-pdf-fill",
        jpg: "icon-tupian",
        png: "icon-tupian",
        gif: "icon-tupian",
        jpeg: "icon-tupian",
        txt: "icon-wenjian",
        unKnown: "icon-bg-unknownfile"
      },
      attachmentShowType: ATTA_FILE_SHOW_TYPE,
      currentAttachment: {},
      preViewObj: {},
      title: null,
      type: null
    };
  },
  components: { ParticipantDialog, animation, ForumInvite, userInfo },
  filters: {
    //取截单元,单位
    fileSizeUnit: arg => {
      if (parseFloat(arg) / (1024 * 1024) > 1) {
        return (parseFloat(arg) / (1024 * 1024)).toFixed(2) + "M";
      } else if (parseFloat(arg) / 1024 > 1) {
        return (parseFloat(arg) / 1024).toFixed(2) + "K";
      } else {
        if (arg) {
          return arg + "B";
        } else {
          return 0 + "B";
        }
      }
    },
    //设置图标的颜色
    fileColor: function(arg, this_) {
      let type = null;
      if (arg.attachmentOriginalName) {
        type = arg.attachmentOriginalName.substring(
          arg.attachmentOriginalName.lastIndexOf(".") + 1
        );
      }

      if (this_.attachmentColors[type]) {
        return "color:" + this_.attachmentColors[type];
      } else {
        return "color:" + this_.attachmentColors["unKnown"];
      }
    },

    //设置类图标
    fileIcon: function(arg, this_) {
      let type = null;
      if (arg.attachmentOriginalName) {
        type = arg.attachmentOriginalName.substring(
          arg.attachmentOriginalName.lastIndexOf(".") + 1
        );
      }
      if (this_.fileIconType[type]) {
        return this_.fileIconType[type] + " iconfont";
      } else {
        return this_.fileIconType["unKnown"] + " iconfont";
      }
    }
  },
  mounted() {
    this.initData();
    // this.initPage()
  },
  //销毁时销毁监听器
  beforeDestroy() {
    // window.removeEventListener("resize", this.timeOutChange)
  },

  watch: {
    moduleUserId(newVal) {
      this.currUserId = newVal;
    }
  },
  methods: {
    handleCallback() {
      this.initData();
    },

    //预览附件
    previewAttachment(item) {
      this.preViewObj = item;
      this.preViewObj.url =
        window.config.api.baseUrl +
        "/eims-api/attachment/findFile?token=" +
        cookie.getCookie("token") +
        "&code=" +
        item.code;
      this.showPreview = true;
    },

    //下载附件
    downloadAttachment(item) {
      let fileType = item.attachmentOriginalName.substring(
        item.attachmentOriginalName.lastIndexOf(".") + 1
      );
      const elink = document.createElement("a");
      http
        .get(
          window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code,
          { responseType: "blob" }
        )
        .then(response => {
          if (response) {
            let attaFileDownTypeElement = this.attachmentShowType[fileType];
            elink.download = item.attachmentName
              ? item.attachmentName + "." + fileType
              : item.attachmentOriginalName;
            elink.style.display = "none";
            elink.target = "_blank";
            elink.href = URL.createObjectURL(
              new Blob([response.data], { type: attaFileDownTypeElement })
            );
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.attachmentPreviewVisible = false;
        });
    },

    handleViewOrDownLoadAttachment(item) {
      this.attachmentPreviewVisible = true;
      this.currentAttachment = item;
    },

    applyHandler() {
      this.applyDialogVisible = true;
    },

    sureApplyHandler() {
      this.isLoading = true;
      let that = this;
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/apply", {
          token: cookie.getCookie("token"),
          data: {
            postCode: that.caseDiscuss.postCode
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            Message.success({
              message: "您的信息已提交审核！",
              showClose: true
            });
          }
        })
        .finally(() => {
          this.applyDialogVisible = false;
          this.isLoading = false;
        });
    },

    handleInviteMember: function() {
      // this.$refs['forum-invite'].changeDialogStatus(true, this.caseDiscuss, 'add', this.currUserId)
      this.title = "添加参与人";
      this.type = "add";
      this.participantDialogVisible = true;
    },
    handleRemoveMember() {
      // this.$refs['forum-invite'].changeDialogStatus(true, this.caseDiscuss, 'remove', this.currUserId)
      this.title = "移除参与人";
      this.type = "remove";
      this.participantDialogVisible = true;
    },
    initData() {
      let _this = this;
      this.$store.dispatch("getUserInfo").then(value => {
        _this.currUserId = _this.$store.state.userModule.userShare.userId;
      });
      this.caseDiscuss.isLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/discuss/detail", {
          token: cookie.getCookie("token"),
          data: {
            postCode: _this.$route.query.id,
            tmp: _this.$route.query.tmp
          }
        })
        .then(response => {
          let data = response.data.data;
          _this.caseDiscuss = data.article;
        })
        .finally(() => {
          _this.caseDiscuss.isLoading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },

    initPage() {
      window.addEventListener("resize", this.timeOutChange, false);
      this.timeOutChange();
    },

    timeOutChange() {
      let that = this;
      if (this.spanTimeout !== null) {
        clearTimeout(this.spanTimeout);
        this.spanTimeout = null;
      }

      this.spanTimeout = setTimeout(() => {
        that.windowSizeChange();
      }, 10);
    },

    //窗口发生变化
    windowSizeChange() {
      let attachmentPanel = document.getElementsByClassName(
        "detail-attachment-panel"
      )[0];
      this.attachmentSpan = generateStandardSpan(
        attachmentPanel.offsetWidth,
        this.attachmentSensitive
      );

      let memberPanel = document.getElementsByClassName(
        "detail-footer-panel"
      )[0];
      this.memberSpan = generateStandardSpan(
        memberPanel.offsetWidth,
        this.memberSensitive
      );
    },
    handleShowUserInfo(item) {
      this.view.userId = item.userId;
      this.view.viewDialogFlag = true;
    }
  },

  computed: {
    showParticipant() {
      if (!this.$store.state.userModule) return;
      const item = this.caseDiscuss.users.find(
        i => i.userId === this.moduleUserId
      );
      return this.deptPower || item;
    },
    ...mapState({
      moduleUserId: state => state.userModule.userShare.userId,
      deptPower: state => state.userPowerStore.deptPower
    })
  }
};
</script>

<style scoped>
.forum-detail {
  margin: 20px;
}

.btn-back {
  position: relative;
  margin-left: calc(100% - 70px);
  right: 10px;
}

.icon-icon_yanjing1 {
  font-size: 24px;
  color: rgb(52, 212, 238);
}

.forum-panel {
}

.detail-title {
  line-height: 50px;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}

.detail-title-text {
  margin: 20px 30px;
  display: inline-block;
  text-align: left;
}

.tag {
  line-height: 40px;
  font-size: 20px;
  font-weight: bold;
}

.detail-content {
  text-indent: 2em;
  font-size: 18px;
  line-height: 26px;
}

.detail-attachment-panel {
  margin: 40px 0;
  display: flex;
  flex-direction: column;
}

.detail-attachment-items {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}

.detail-attachment-item {
  flex-shrink: 1;
  flex-grow: 1;
  width: 200px;
  box-shadow: 0 0 10px #d9d9d9;
  padding: 10px;
  border-radius: 5px;
  display: inline-block;
  height: 130px;
  margin: 8px 10px;
  background-color: rgb(238, 245, 252);
  cursor: pointer;
}

.detail-attachment-item:hover {
  box-shadow: 0px 0px 20px #b1b0b0;
  transition: all 300ms;
}

.member-item {
  display: inline-block;
  width: 100%;
}

.up-left {
  display: inline-block;
  width: calc(100% - 60px);
}

.up-right {
  margin-left: 10px;
  vertical-align: top;
  color: #5c5b5b;
  font-size: 40px;
}

.member-item-up {
  border-radius: 8px;
  border: 3px solid #e2dddd;
  background-size: cover;
  width: 50px;
  height: 50px;
  margin: 5px auto;
}

.member-item-down {
  font-size: 14px;
  width: 50px;
  margin: 0 auto;
}

.user-name {
  line-height: 20px;
  text-align: center;
  width: 100%;
  /*将元素设置行内块元素，否则下面的设置将会无效*/
  display: inline-block;
  /*将超出的文本隐藏*/
  overflow: hidden;
  /*设置文本超出span长度之需要设置为不换行*/
  white-space: nowrap;
  /*将溢出的文本使用...显示*/
  text-overflow: ellipsis;
}

.attachment-item-up {
  display: inline-block;
  width: 100%;
  height: 80px;
}

.attachment-name {
  /*强制英文换行*/
  word-wrap: break-word;
  white-space: normal;
  height: 50px;
  line-height: 25px;
  width: 100%;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*设置文本只显示的行数*/
  -webkit-line-clamp: 2;
  /*设置文本显示纵向排版*/
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.attachment-item-down {
  border-top: 2px solid #bababa;
  padding: 5px;
  font-size: 16px;
  font-weight: normal;
  color: #afafaf;
}

.attachment-size {
  line-height: 28px;
  display: block;
  color: #9a9a9a;
}

.container-body {
  padding: 10px 40px;
}

.icon-tianjia:before {
  line-height: 46px;
  font-size: 30px;
  margin-left: 5px;
}

.icon-jianshao:before {
  cursor: pointer;
  line-height: 45px;
  font-size: 30px;
  margin-left: 6px;
}

.member-item-add {
  display: flex;
  flex-direction: column;
  width: 50px;
  user-select: none;
}

.member-item-reduce {
  display: flex;
  flex-direction: column;
  width: 50px;
  user-select: none;
}

.other-info {
  color: #a7a7a7;
  line-height: 24px;
  font-size: 18px;
  font-weight: normal;
  display: block;
  width: 100%;
  height: 80px;
}

.detail-author {
  clear: both;
  display: block;
  float: right;
  text-align-last: left;
}

.detail-time {
  clear: both;
  display: block;
  float: right;
}

.default-content {
  height: 50px;
  cursor: pointer;
  display: block;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  color: yellowgreen;
}

.default-content:after {
  content: "\e601";
}

.detail-footer-panel {
  display: flex;
  flex-direction: column;
}

.member-item-wrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  cursor: pointer;
}

.member-item-wrapper > * {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/forum/detail/ForumDetail.vue